import { Outlet } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FloatingWhatsApp from "@/components/layout/FloatingWhatsApp";
import CodeInjection from "@/components/CodeInjection";

export default function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-surface">
      {/* Admin-managed analytics/tracking scripts. Renders nothing itself. */}
      <CodeInjection />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
